import { useState, useEffect, useMemo } from 'react';
import { isRowSelectable } from '../utils/rows';

// เลือกหลายรายการพร้อมกัน (checkbox หน้าคอลัมน์ "ลำดับ") แล้วอนุมัติ/ปฏิเสธ/รอก่อนทีเดียวได้ — เลือกได้
// เฉพาะแถวที่มี checkbox โชว์อยู่จริงเท่านั้น (isRowSelectable — ไม่ finalized และยังเป็น PENDING) กัน
// "เลือกทั้งหมด" ไปเลือกแถวที่ตัดสินใจไปแล้ว (ไม่มี checkbox ให้เห็นบนจอ) ล้าง selection ทุกครั้งที่สลับแท็บ
export function useRowSelection(rows, tab, statusField) {
  const [selectedIds, setSelectedIds] = useState(() => new Set());
  useEffect(() => {
    setSelectedIds(new Set());
  }, [tab]);

  const toggleSelectRow = (id) => {
    setSelectedIds((prev) => {
      const next = new Set(prev);
      if (next.has(id)) {
        next.delete(id);
      } else {
        next.add(id);
      }
      return next;
    });
  };

  const selectableRows = useMemo(
    () => rows.filter((r) => isRowSelectable(r, statusField)),
    [rows, statusField],
  );
  const allSelected =
    selectableRows.length > 0 &&
    selectableRows.every((r) => selectedIds.has(r._id));
  const toggleSelectAll = () => {
    setSelectedIds(
      allSelected ? new Set() : new Set(selectableRows.map((r) => r._id)),
    );
  };

  return { selectedIds, setSelectedIds, toggleSelectRow, allSelected, toggleSelectAll };
}
